export default __webpack_public_path__ + "6a7c812.png";